<template>
  <div :class="'dialog-overlay ' + size" v-if="canView()">
    <!-- <v-overlay color="white"> -->
    <!-- <v-scale-transition origin="center center 0 "> -->
    <div v-if="open && step" class="tutorial font-dm" :style="getStyle()">
      <div class="tutorialEnd">
        <div class="tutorialContent px-5 pb-5 pt-2 text-center rounded-un">
          <div class="text-right">
            <v-icon small dark @click="end()">mdi-close</v-icon>
          </div>
          <p>
            {{ steps[step].text }}
          </p>
          <v-btn dark color="#ffffff" class="rounded-un color-purple" block depressed x-large @click="close()">
            {{ steps[step].botao }}
          </v-btn>
        </div>
        <div class="tutorialEndBackground rounded-un">
          <div
            class="arrow-down-purple"
            :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
            v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'bottom' : steps[step].arrowMobile === 'bottom'"
          ></div>
          <div
            class="arrow-up-purple"
            :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
            v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'top' : steps[step].arrowMobile === 'top'"
          ></div>
          <div
            class="arrow-left-purple"
            :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
            v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'left' : steps[step].arrowMobile === 'left'"
          ></div>
          <div
            class="arrow-right-purple"
            :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
            v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'right' : steps[step].arrowMobile === 'right'"
          ></div>
        </div>
        <div
          class="arrow-down"
          :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
          v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'bottom' : steps[step].arrowMobile === 'bottom'"
        ></div>
        <div
          class="arrow-up"
          :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
          v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'top' : steps[step].arrowMobile === 'top'"
        ></div>
        <div
          class="arrow-left"
          :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
          v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'left' : steps[step].arrowMobile === 'left'"
        ></div>
        <div
          class="arrow-right"
          :style="$vuetify.breakpoint.mdAndUp ? steps[step].stArDk : steps[step].stArMb"
          v-if="$vuetify.breakpoint.mdAndUp ? steps[step].arrow === 'right' : steps[step].arrowMobile === 'right'"
        ></div>
      </div>
    </div>
    <!-- </v-scale-transition> -->
    <!-- </v-overlay> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['tutorial', 'reset', 'popup', 'journeyDialog', 'logged', 'error', 'sequence']),
    route() {
      return this.$route.path
    },
  },
  data: () => ({
    open: false,
    disabled: false,
    rolando: true,
    step: 0,
    size: '',
    steps: [
      {
        text:
          'Hey, Conecta escrevendo aqui! \\o Esse é o nosso quiz, ele vai aparecer conforme você interagir com a plataforma. Tudo pra gente saber se você tá curtindo a jornada e pra te conhecer melhor, beleza?',
        viewed: false,
      }, // 0
      {
        text: 'Beleza! Deixaremos salvo na home pra quando você quiser responder.',
        botao: 'CONTINUAR',
        altStyle: 'top: 250px; left: 50%; margin-left:-400px !important;',
        style: 'top: 370px; left: 50%; margin-left:-400px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'left',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: '',
        stArMb: 'left: 5% !important;',
      }, // 1
      {
        text:
          'Aqui na home, conforme você avançar na exploração da plataforma, vai encontrar sempre conteúdos novos, além da sua barra de progresso, que mostra sua evolução em cada etapa! Abra a primeira matéria para testar!',
        botao: 'CONTINUAR',
        style: 'top: 250px; left: 50%; margin-left:-400px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'left',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: '',
        stArMb: 'left: 5% !important;',
      }, // 2 ok
      {
        text: 'UHUL, pode explorar à vontade então! Se voltar a precisar de ajuda, é só ativar o tutorial de volta nas configurações. Agora é contigo ;)',
        botao: 'CONTINUAR',
        style: 'top: 160px; left: 50%; margin-left:-250px !important;',
        styleMobile: 'top: 160px; left: 50%; max-width:280px; margin-left:-140px !important;',
        arrow: 'left',
        arrowMobile: 'left',
        viewed: false,
        stArDk: '',
        stArMb: '',
      }, // 3
      {
        text: 'Dica! 🤓 Você pode salvar qualquer conteúdo pra ler depois! É só clicar na bandeira, e o item vai ficar guardado na seção de salvos, perto da barra de progresso na home.',
        botao: 'CONTINUAR',
        style: 'top: 400px; left: 50%; margin-left:0px !important;',
        styleMobile: 'top: 230px;  left: 2%; width:80%; max-width:90%;',
        arrow: 'right',
        arrowMobile: 'right',
        viewed: false,
        stArDk: 'top: 190px !important;',
        stArMb: '',
      }, // 4 ok
      {
        text: 'Quanto mais você interagir com a plataforma, mais rápido avança na sua jornada e ainda recebe conteúdos que combinam com você.',
        botao: 'CONTINUAR',
        style: 'bottom: 120px; left: 40%; margin-left:-250px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'bottom',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: '',
        stArMb: 'left: 20px !important;',
      }, // 5 ok
      {
        text:
          'Se liga: toda vez que bater um nervoso sobre teu futuro profissional, entra aqui e quem sabe não tem um conteúdo perfeito pra te ajudar? Lembra sempre que somos humanos em construção e que você já está evoluindo nessa jornada. Conta com a gente!',
        botao: 'CONTINUAR',
        style: 'top: 320px; left: 50%; margin-left:-400px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'left',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: 'top: 130px !important;',
        stArMb: 'left: 25% !important;',
      }, // 6 ok
      {
        text:
          'Se você quiser ir além, aqui é seu lugar! A sua jornada de descoberta e autoconhecimento, também acontece lá fora. Por isso aqui você encontra conteúdos que vão te ajudar a voar sozinho. Mas você sempre pode retornar aqui, ok?',
        botao: 'CONTINUAR',
        style: 'top: 320px; left: 50%; margin-left:-400px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'left',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: 'top: 170px !important;',
        stArMb: 'left: 50% !important;',
      }, // 7 ok
      {
        text: 'É hora de ativar a curiosidade e partir nesta jornada rumo ao seu futuro. Clique no botão e se jogue para avançar nas etapas.',
        botao: 'CONTINUAR',
        style: 'bottom: 120px; left: 40%; margin-left:-250px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'bottom',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: '',
        stArMb: 'left: 45% !important;',
      }, // 8 ok
      {
        text: 'Aqui você pode checar seu progresso na jornada! Suas recompensas, desenvolvimento e quanto falta pra avançar de etapa!',
        botao: 'CONTINUAR',
        style: 'top: 260px; left: 50%; margin-left:-300px !important;',
        styleMobile: 'bottom: 60px; left: 10%; width:80%; max-width:90%;',
        arrow: 'top',
        arrowMobile: 'bottom',
        viewed: false,
        stArDk: 'left: 25% !important;',
        stArMb: 'right: 35% !important;',
      }, // 9 ok
      {
        text: 'Nos conectamos com alguns parceiros, e preparamos recompensas para você. Clica na recompensa liberada e leia bem as instruções de uso. ;)',
        botao: 'CONTINUAR',
        style: 'bottom: 120px; left: 50%; margin-left:-250px !important;',
        styleMobile: 'bottom: 40px; left: 10%; width:80%; max-width:90%;',
        arrow: 'top',
        arrowMobile: 'top',
        viewed: false,
        stArDk: '',
        stArMb: 'left: 25% !important;',
        route: '/jornada',
        // 10
      },
    ],
    oldStep: [],
  }),
  methods: {
    close() {
      this.steps[this.step].viewed = true
      localStorage.setItem('tutorial', JSON.stringify({ steps: this.steps }))
      if (this.step === 9) {
        this.$store.dispatch('setScrollInfo', true)
      }
      this.open = false
      this.step = null
      this.oldStep = this.steps
    },
    getStyle() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        if (this.$route.path === '/' && this.step === 1) {
          return this.steps[this.step].altStyle
        }
        return this.steps[this.step].style
      }
      return this.steps[this.step].styleMobile
    },
    openTutorial(i) {
      this.$store.dispatch('setScrollInfo', false)
      if (!this.steps[i].viewed) {
        this.open = true
        this.step = i
      } else {
        this.$store.dispatch('setTutorialInfo', {
          open: false,
          step: i,
        })
      }
    },
    end() {
      this.step = null
      this.open = false
      this.$store.dispatch('setTutorialInfo', null)
      this.$store.dispatch('setScrollInfo', true)
      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].viewed = true
      }
      localStorage.setItem('tutorial', JSON.stringify({ steps: this.steps }))
      this.oldStep = this.steps
      this.$store.dispatch('setErrorInfo', {
        open: true,
        text: 'UHUL, pode explorar à vontade então! Se voltar a precisar de ajuda, é só ativar o tutorial de volta nas configurações. Agora é contigo ;)',
      })
    },
    functionReset() {
      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].viewed = false
      }
      this.step = null
      this.open = false
    },
    canView() {
      if (
        this.route === '/jornada' ||
        this.route === '/jornada#explorando' ||
        this.route === '/jornada#descobrindo' ||
        this.route === '/jornada#experimentando' ||
        this.route === '/jornada#escolhendo' ||
        this.route === '/jornada#bonus'
      ) {
        return this.open && this.step && this.logged && !this.journeyDialog && !this.error && !this.disabled
      } else {
        return this.open && this.step && this.logged && !this.journeyDialog && !this.error && !this.sequence && !this.disabled && !this.popup
      }
    },
  },
  watch: {
    tutorial() {
      if (this.tutorial) {
        if (this.tutorial.open === false && this.tutorial.step === 0) {
          this.steps[0].viewed = true
          localStorage.setItem('tutorial', JSON.stringify({ steps: this.steps }))
        }
        if (this.tutorial.open === true && this.tutorial.type === 'quiz' && this.steps[this.tutorial.step].viewed === false) {
          const quiz = {
            title: this.steps[this.tutorial.step].text,
            quiz_type: 'form',
            button_text: 'Continuar',
            ignore: true,
            description: '', //this.steps[this.tutorial.step].text,
          }
          this.$store.dispatch('setPopupInfo', quiz)
          this.steps[this.tutorial.step].viewed = true
          localStorage.setItem('tutorial', JSON.stringify({ steps: this.steps }))
          this.oldStep = this.steps
        }
        if (this.tutorial.open === true && this.tutorial.type !== 'quiz') {
          if (this.tutorial.size) {
            this.size = 'size-pc'
          } else {
            this.size = 'size-vh'
          }
          this.openTutorial(this.tutorial.step)
        }
      }
    },
    reset() {
      if (this.reset === true) {
        this.functionReset()
        this.$store.dispatch('setResetInfo', false)
      }
    },
    route() {
      if (this.step === 10) {
        if (
          this.route === '/jornada' ||
          this.route === '/jornada#explorando' ||
          this.route === '/jornada#descobrindo' ||
          this.route === '/jornada#experimentando' ||
          this.route === '/jornada#escolhendo' ||
          this.route === '/jornada#bonus'
        ) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 9) {
        if (
          this.route === '/jornada' ||
          this.route === '/jornada#explorando' ||
          this.route === '/jornada#descobrindo' ||
          this.route === '/jornada#experimentando' ||
          this.route === '/jornada#escolhendo' ||
          this.route === '/jornada#bonus'
        ) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 8) {
        const r = this.$route.path.split('/')
        if (r[1] === 'acoes' && r[2]) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 5) {
        const r = this.$route.path.split('/')
        if (r[1] === 'ideias' && r[2]) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 6) {
        const r = this.$route.path.split('/')
        if (r[1] === 'ideias' && !r[2]) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 7) {
        const r = this.$route.path.split('/')
        if (r[1] === 'acoes' && !r[2]) {
          this.disabled = false
        } else {
          this.disabled = true
        }
      } else if (this.step === 1) {
        const r = this.$route.path.split('/')
        if (r[1] === 'jornada') {
          this.disabled = true
        } else {
          this.disabled = false
        }
      } else {
        this.disabled = false
      }
    },
  },
  mounted() {
    this.oldStep = this.steps
    const history = localStorage.getItem('tutorial')
    if (history) {
      const raw = JSON.parse(history)
      this.steps = raw.steps
    } else {
      localStorage.setItem('tutorial', JSON.stringify({ steps: this.steps }))
    }
  },
}
</script>

<style>
.dialog-overlay {
  max-width: 100vw;
  width: 100vw;
  background: #ffffff44;
  z-index: 1000;
}

.size-vh {
  position: fixed;
  max-height: 100vh;
  height: 100vh;
}
.size-pc {
  position: absolute;
  max-height: 100%;
  height: 100%;
}

.dialog-overlay .v-overlay {
  display: block;
}
</style>
